export function getParts(productId: string): string {
    if (productId === '81596'){
        return '100000'
    }
    if (productId === '81634'){
        return '100001'
    }
    return ''
}

export function getProductId(parts: string): string {
    if (parts === '100000'){
        return '81596'
    }
    if (parts === '100001'){
        return '81634'
    }
    return ''
}